import React, { FC } from 'react';

import { ResolutionContent } from '../ResolutionContent';

interface ButtonLabelProps {
  label: Queries.ButtonFragment['label'];
}
export const ButtonLabel: FC<ButtonLabelProps> = ({ label }) => {
  return (
    <ResolutionContent
      defaultContent={label?.default}
      mobileContent={label?.mobile}
    />
  );
};
